import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ErrorMessage from '../ErrorMessage';
import './SourceMappingList.scss';

export default class SourceMappingList extends PureComponent {
  actionFormatter = (cell, row) => (
    <Link
      className="btn btn-secondary"
      to={{ pathname: `/source/${row.dealer_id}` }}
    >
      Edit
    </Link>
  );

  createCustomInsertButton = () => (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: '/source/' }}
    >
      Add New
    </Link>
  );

  render() {
    const { list, error } = this.props;

    const options = {
      insertBtn: this.createCustomInsertButton,
    };

    return (
      <div className="source-mapping-list-container">
        {error && <ErrorMessage error={error} />}
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
        >
          <TableHeaderColumn isKey dataField="id" dataSort>
            ID
          </TableHeaderColumn>
          <TableHeaderColumn dataField="createdAt" dataSort>
            Created At
          </TableHeaderColumn>
          <TableHeaderColumn dataField="updatedAt">
            Updated At
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

SourceMappingList.propTypes = {
  error: PropTypes.any,
  list: PropTypes.array,
};
